import React from "react";
import { useSelector } from "react-redux";
import MoneyDisplay from "../../../../components/moneyDisplay/moneyDisplay";
import PercentChanged from "../../../../components/percentChanged/percentChanged";

const YearToDate = () => {
  const { totalRevenueYTD, totalRevenueYTDRawDataLink, currencySymbol, totalRevenueYTDChange } =
    useSelector((state) => state.totalRevenue.allRevenues);
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <>
      <MoneyDisplay
        value={totalRevenueYTD}
        url={totalRevenueYTDRawDataLink}
        currency={currencySymbol}
        size={44}
        disableAnimation={isUserQa}
      />
      <PercentChanged
        changeValue={totalRevenueYTDChange}
        currencySymbol={currencySymbol}
        toolTip="Percentage change from previous year"
        showBorder
      />
    </>
  );
};

export default YearToDate;
